import { Calendar, Clock } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionTag } from "./SectionTag";

export function BookCall() {
  return (
    <section id="rdv" className="bg-cream-deep py-24">
      <div className="mx-auto max-w-3xl px-6 text-center lg:px-8">
        <Reveal>
          <SectionTag>Rendez-vous</SectionTag>
          <h2 className="mt-5 text-4xl font-extrabold tracking-tight text-ink lg:text-5xl">
            Prenez rendez-vous avec l'un de nos conseillers
          </h2>
          <p className="mt-4 text-lg text-ink-soft">
            20 minutes pour comprendre votre commerce, répondre à vos questions et voir
            si Wara Cards est fait pour vous — sans engagement.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 rounded-2xl border border-line bg-white p-10 shadow-card">
            <div className="mx-auto flex max-w-sm flex-col gap-3 text-left">
              <div className="flex items-center gap-3 text-sm text-ink-soft">
                <Clock size={16} className="text-coral" />
                20 minutes, en visio ou par téléphone
              </div>
              <div className="flex items-center gap-3 text-sm text-ink-soft">
                <Calendar size={16} className="text-coral" />
                Au créneau qui vous arrange
              </div>
            </div>

            <a
              href="#demo"
              className="mt-8 inline-flex rounded-full bg-ink px-8 py-4 text-sm font-semibold text-white shadow-soft transition-transform hover:scale-[1.03]"
            >
              Réserver mon créneau →
            </a>
            <p className="mt-3 text-xs text-ink-soft">
              Aucune carte bancaire requise.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
